






































import { stringToCodePoints } from '@/utils/helpers'
import Vue from 'vue'

export default Vue.extend({
  name: 'MailTemplate',
  data() {
    return {
      body: '',
      isDeleting: false,
      isSaving: false,
      templateId: ''
    }
  },
  computed: {
    BODY_MAX_LENGTH(): number {
      return 300
    },

    /**
     * ページタイトル
     */
    pageTitle(): string {
      return this.$route.params.template_id ? 'テンプレート編集' : 'テンプレート作成'
    },

    /**
     * 本文の長さ
     */
    bodyLength(): number {
      return stringToCodePoints(this.body).length
    },

    /**
     * body が最大文字数を超えたか
     */
    isBodyMaxLengthOver(): boolean {
      return this.bodyLength > this.BODY_MAX_LENGTH
    }
  },
  created(this: any) {
    if (this.$route.params.template_id) {
      this.templateId = this.$route.params.template_id
      this.body = this.$store.getters['MessageTemplate/templates'][this.templateId].body
    }
  },
  methods: {
    async saveTemplate() {
      if (this.bodyLength === 0) {
        this.$_alert('本文を入力してください')
        return
      }
      if (this.isBodyMaxLengthOver) {
        this.$_alert(`本文は${this.BODY_MAX_LENGTH}文字以内で入力してください`)
        return
      }

      this.isSaving = true
      await this.$nextTick()

      const data = await this.$store.dispatch('MessageTemplate/editTemplate', {
        id: this.templateId,
        body: this.body
      })
      if (data.error) {
        this.$_alert('テンプレート作成失敗')
        this.isSaving = false
        console.error(data.error)
        return
      }
      setTimeout(() => {
        this.isSaving = false
        this.$router.back()
      }, 300)
    },

    async removeTemplate() {
      this.isDeleting = true
      const data = await this.$store.dispatch('MessageTemplate/removeTemplate', {
        id: this.templateId
      })
      if (data.error) {
        this.$_alert('テンプレート削除失敗')
        this.isDeleting = false
        console.error(data.error)
        return
      }
      setTimeout(() => {
        this.isDeleting = false
        this.$router.back()
      }, 500)
    }
  }
})
